import { Grid } from "antd";
import { useSistemaStore } from "features/sistema/store";

export function Footer() {
	const screens = Grid.useBreakpoint();
	const sistema = useSistemaStore((s) => s.sistema);

	return (
		<div
			style={{
				margin: "0 auto",
				padding: screens.md ? "0px 1.33rem 1.33rem" : "0px 1.06rem",
				display: "flex",
			}}
		>
			<div style={{ borderTop: "1px solid #e4e9f0", width: "100%" }}>
				<a
					href={"https://lacto.mercurioapp.com.br"}
					target="_blank"
					rel="noopener noreferrer"
					className="text-lg font-extrabold text-black uppercase"
				>
					Lacto
				</a>

				<span style={{ color: "rgb(89, 92, 151)", paddingLeft: 8 }}>{`${APP_VERSION} - ${CURRENT_COMMIT}`}</span>

				<br />

				<p style={{ marginBottom: 0 }}>
					<span className="text-gray-500 ">Copyright © {sistema?.sis_copyright}</span>
				</p>
			</div>
		</div>
	);
}
